import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Filtro} from '~model/filtro/filtros/filtro';
import {FormControl} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import {ToolbarFiltroItemState, ToolbarFiltroItemStore} from './toolbar-filtro-item.store';
import {RotaVo} from '~model/vo/rota-vo';

@Component({
  selector: 'app-toolbar-filtro-item',
  templateUrl: './toolbar-filtro-item.component.html',
  styleUrls: ['./toolbar-filtro-item.component.scss'],
  providers: [ToolbarFiltroItemStore],
})
export class ToolbarFiltroItemComponent implements OnInit {

  @Input() filtroNome: string = '';
  @Input() nome: string = '...';
  @Input() modoHorario: boolean = false;
  @Output() objChange: EventEmitter<Filtro<RotaVo>> = new EventEmitter();

  comparadores: import('rxjs').Observable<string[]> = this.store.select(state => state.comparadores.toArray());
  comparadoresTamanho: import('rxjs').Observable<number> = this.store.select(state => state.comparadores.size);
  comparadoresForm: FormControl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  valorPrevio: string = '';

  // Time picker customizado
  isTimePickerOpen: boolean = false;
  selectedTime: string = '';
  selectedTimeDisplay: string = ''; // Para exibição em formato 12h

  constructor(private readonly store: ToolbarFiltroItemStore) {
  }

  ngOnInit(): void {
    this.store.inicializarFiltro(this.filtroNome);
    this.store.onObjChange(this.objChange);
  }

  // Métodos para o time picker customizado
  openTimePicker(): void {
    this.isTimePickerOpen = true;
  }

  // Reseta o valor selecionado (chamado pelo "Limpar" do painel) sem destruir o componente
  reset(): void {
    this.store.resetFiltro();
    this.comparadoresForm.setValue(null);
    this.valorPrevio = '';
    this.selectedTime = '';
    this.selectedTimeDisplay = '';
  }

  private convertTo12HourFormat(time24: string): string {
    const [hours, minutes] = time24.split(':');
    const hour = parseInt(hours, 10);
    const minute = parseInt(minutes, 10);

    let hour12 = hour;
    let period = 'AM';

    if (hour === 0) {
      hour12 = 12;
    } else if (hour === 12) {
      period = 'PM';
    } else if (hour > 12) {
      hour12 = hour - 12;
      period = 'PM';
    }

    return `${hour12.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${period}`;
  }

  onTimeSelected(time: string): void {
    this.selectedTime = time;
    this.selectedTimeDisplay = this.convertTo12HourFormat(time); // Atualiza a exibição em formato 12h
    this.timePickerChange(time);
  }

  onTimePickerClosed(): void {
    this.isTimePickerOpen = false;
  }

  // Limpa o horário selecionado (X no lugar do relógio) — emite o filtro vazio,
  // que é aplicado imediatamente pelo painel
  clearTime(): void {
    this.timePickerChange('');
    this.selectedTime = '';
    this.selectedTimeDisplay = '';
    this.atualizarValorPrevio();
  }

  add(event: MatChipInputEvent): void {
    const inputElement = event.chipInput?.inputElement;
    const value = event.value;

    if ((value || '').trim()) {
      this.store.saveComparador(value);
    }

    if (inputElement) {
      inputElement.value = '';
    }

    this.atualizarValorPrevio();
    this.comparadoresForm.setValue(null);
  }

  addFromInput(inputElement: HTMLInputElement): void {
    const value = inputElement.value;

    if ((value || '').trim()) {
      this.store.saveComparador(value);
      inputElement.value = '';
      this.atualizarValorPrevio();
      this.comparadoresForm.setValue(null);
    }
  }

  remove(filtro: string): void {
    const lista = this.state.comparadores;
    const index = lista.indexOf(filtro);

    if (index >= 0) {
      this.store.deleteComparador(index);
    }

    this.atualizarValorPrevio();
  }

  timePickerChange($event: string): void {
    this.store.setState(state => ({...state, comparadores: state.comparadores.clear()}));

    this.store.saveComparador($event);
    this.atualizarValorPrevio();
  }

  atualizarValorPrevio(): void {
    const tamanho = this.store.comparadores.length;

    if (this.modoHorario && this.selectedTimeDisplay) {
      this.valorPrevio = tamanho > 1 && tamanho !== 0 ? `${tamanho} +` : this.selectedTimeDisplay;
    } else {
      this.valorPrevio = tamanho > 1 && tamanho !== 0 ? `${tamanho} +` : this.state.comparadores.get(0) ?? 'Todos';
    }
  }

  get state(): ToolbarFiltroItemState {
    return this.store.getState();
  }
}
